<template>
  <div>
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm go-to-table"
      v-on:click="scrollToDynamicTable" :disabled="loading"
    >
      Таблица
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm download-button"
      v-on:click="downloadCsv" :disabled="loading"
    >
      {{buttonText}}
    </button>
  </div>
</template>

<script>
import ChartAPI from "./chart-api";
import {mapGetters} from "vuex";

function waitForElementToDisplay(elementId, time, callback) {
  let interval = setInterval(function() {
    let element = document.getElementById(elementId);
    if(element) {
      clearInterval(interval);
      callback(element);
    }
  }, time);
}

export default {
  name: "DownloadOrGoToSOVTable",
  props: {
    downloadReportType: {
      type: String,
      default: "download-sov"
    },
    urls : {
      type: Array,
      default: []
    },
    accordion: {
      type: Boolean,
      default: false
    }
  },


  data(){
    return {
      studObj: new ChartAPI(),
      loading: false,
    }
  },
  computed: {
    buttonText: function () {
      return "Скачать";
    },
    ...mapGetters(["currentProjectId"]),
  },
  methods: {
    async downloadCsv() {
      this.loading = true
      let studObj = new ChartAPI();
      await studObj.getDownloadReport(this.downloadReportType, this.urls, this.currentProjectId);
      this.loading = false;
    },

    scrollToDynamicTable() {
      const header = document.getElementById('sov_dynamic_table_header');
      if (header) {
        header.scrollIntoView({ behavior: 'smooth' });
        if (this.accordion === false) {
          header.click();
        }
        waitForElementToDisplay('tab-btn-1', 100, function(element) {
          if (element) {
            element.click()
          }
        });
      }
    },
  }
}
</script>

<style scoped>

</style>